@if (!isEditable) {
  <span>{{ displayValue }}</span>
}

@if (isEditable) {
  <topo-switch
    (click)="onClick()"
    [checked]="value"
  ></topo-switch>
}
